export default "__VITE_ASSET__520c38ae__"